<template>
  <q-form ref="form" class="full-width q-px-md q-pb-md">
    <div class="col-12" v-if="formData.id && currentUserData.role == 'Admin'">
      <q-tabs v-if="data" v-model="tab">
        <q-tab name="general" label="General" />
        <q-tab name="permissions" label="Permissions" />
      </q-tabs>
    </div>
    <div class="row items-center q-pt-md" v-if="tab == 'general'">
      <!-- <div class="col-12" v-if="formData.hasOwnProperty('id')">
        <div style="margin: auto">
          <q-btn
            class="full-width"
            outline
            color="primary"
            @click="resetTemporaryPassword()"
          >
            Reset Temporary Password
          </q-btn>
          <p class="mb-0">
            * This will give the user a new Temporary password, and send them an
            email with the new login details
          </p>
        </div>
      </div> -->
      <div class="col-12 q-px-sm">
        <q-input
          v-model="formData.email"
          label="Email Address"
          :rules="[
            (v) => !!v || 'Email is required',
            (v) => /.+@.+/.test(v) || 'Email must be valid',
          ]"
        ></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          v-model="formData.name"
          label="Name"
          :rules="[(v) => !!v || 'Name is required']"
        ></q-input>
      </div>
      <div
        class="col-12 q-px-sm"
        v-if="!formData.id || currentUserData.role == 'OrgAdmin'"
      >
        <q-select
          v-model="formData.role"
          :emit-value="true"
          map-options
          label="Role"
          :options="roles"
          :rules="[(v) => !!v || 'Role is required']"
        ></q-select>
      </div>
      <!-- <div v-if="formData.role == 'OrgUser'" class="col-12 q-px-sm">
        <q-checkbox
          v-model="formData.scheduleSurveyPerms"
          label="Allowed to schedule surveys"
          :true-value="1"
          :false-value="0"
        ></q-checkbox>
      </div> -->
      <div
        v-if="currentUserData.role == 'Admin' && !formData.id"
        class="col-12 q-px-sm"
      >
        <assignOrganization
          :id="formData.organization_id"
          @changed="(val) => (formData.organization_id = val)"
        />
      </div>
    </div>
    <div class="row items-center q-pt-md" v-if="tab == 'permissions'">
      <div class="col-12">
        <h6 class="q-my-sm">User Permissions</h6>
      </div>
      <div class="col-12">
        <q-select
          v-model="newPermissionFormData.role"
          :emit-value="true"
          map-options
          label="Role"
          :options="roles"
          :rules="[(v) => !!v || 'Role is required']"
        ></q-select>
        <assignOrganization
          v-if="
            newPermissionFormData.role &&
            newPermissionFormData.role.includes('Org')
          "
          :id="newPermissionFormData.ref_id"
          @changed="(val) => (newPermissionFormData.ref_id = val)"
        />

        <q-btn
          flat
          @click="addUserPermission"
          class="full-width"
          :disable="!newPermissionFormData.role"
          :loading="addUserPermissionLoading"
        >
          <q-icon name="mdi-plus"></q-icon> Add Permission
        </q-btn>
      </div>
      <div class="col-12" style="height: 300px !important">
        <datatable
          :filter="search"
          :flat="true"
          :data="formData.permissions"
          :columns="columns"
        >
          <template slot="body-cell-name" slot-scope="data">
            <q-td :props="data.props">
              {{ !data.props.row.name ? "TDRI" : data.props.row.name }}
              <q-tooltip>{{
                !data.props.row.name ? "TDRI" : data.props.row.name
              }}</q-tooltip>
            </q-td>
          </template>
          <template slot="body-cell-actions" slot-scope="data">
            <q-td :props="data.props">
              <q-btn
                :loading="removingPermissionsID == data.props.row.id"
                @click="removePermissions(data.props.row.id)"
                round
                flat
                color="secondary"
              >
                <q-icon name="mdi-delete"></q-icon>
              </q-btn>
            </q-td>
          </template>
        </datatable>
      </div>
    </div>
  </q-form>
</template>

<script>
import assignOrganization from "@/components/organizations/assignOrganization.vue";
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";

export default {
  components: {
    assignOrganization,
    datatable,
  },
  computed: {
    ...mapGetters(["currentUser", "currentUserData"]),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  watch: {
    data: function () {
      this.init();
    },
  },
  data: () => ({
    // Extra Data
    formData: {},
    newPermissionFormData: {},
    addUserPermissionLoading: false,
    removingPermissionsID: null,
    roles: [
      {
        label: "Organisation Admin",
        value: "OrgAdmin",
      },
      {
        label: "Organisation User",
        value: "OrgUser",
      },
    ],
    columns: [
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "name",
        sortable: true,
      },
      {
        name: "role",
        label: "Role",
        align: "left",
        field: "role",
        sortable: true,
      },

      {
        name: "actions",
        label: "Actions",
        align: "left",
        field: "actions",
        sortable: true,
      },
    ],

    tab: "general",
  }),
  mounted() {
    setTimeout(() => {
      this.init();
    }, 100);
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      } else {
        this.formData = {};
      }
      if (this.currentUserData.role == "Admin") {
        this.roles = [
          {
            label: "Admin",
            value: "Admin",
          },
          {
            label: "Organisation Admin",
            value: "OrgAdmin",
          },
          {
            label: "Organisation User",
            value: "OrgUser",
          },
        ];
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store.dispatch("newUser", this.formData).then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$emit("close", true);
                this.formData = {};
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message,
                });
              }
            });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      }, 200);
    },
    save() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$store.dispatch("saveUser", this.formData).then((result) => {
          this.$emit("loadingStateChanged", false);
          if (result.Result == "Success") {
            this.address = "";
            this.$emit("close", true);
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: "User has been saved",
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
      });
    },
    addUserPermission() {
      this.newPermissionFormData.users_id = this.formData.id;
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$store
          .dispatch("addUserPermission", this.newPermissionFormData)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.formData.permissions = result.Response.data;
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "User has been saved",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      });
    },
    removePermissions(id) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete a user permission, do you wish to continue?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#3284E3",
      }).then((res) => {
        if (res.value) {
          this.$emit("loadingStateChanged", true);
          this.$store
            .dispatch("deleteUserPermission", {
              id: id,
              users_id: this.formData.id,
            })
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.formData.permissions = result.Response.data;
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "User has been deleted",
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
        }
      });
    },
    deleteUser() {
      this.$swal({
        title: "Warning",
        text: "You are about to delete a user, do you wish to continue?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#3284E3",
      }).then((res) => {
        if (res.value) {
          this.$emit("loadingStateChanged", true);
          this.$store
            .dispatch("deleteUser", this.formData.auth0_id)
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$emit("close", true);
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "User has been deleted",
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
        }
      });
    },
  },
};
</script>
